<p-table [value]="events"
         [scrollable]="true"
         scrollHeight="600px"
         sortField="EVENT_TIME"
         [sortOrder]="-1"
         [tableStyle]="{'min-width': '50rem'}"
         [lazy]="true"
         [lazyLoadOnInit]="false"
         (onLazyLoad)="lazyLoad($event)"
         [loading]="isLoading">
    <ng-template pTemplate="header">
        <tr *ngIf="totalItems > 0">
            <th scope="col" class="table-col-7" [attr.data-identifier]="dataIdentifierPrefix + '-sort-date'"
                pSortableColumn="EVENT_TIME">Date
                <p-sortIcon field="EVENT_TIME"></p-sortIcon>
            </th>
            <th *ngIf="isOrgAdminApp()" scope="col" class="table-col-9" [attr.data-identifier]="dataIdentifierPrefix + '-username'">Username
            </th>
            <th *ngIf="!isOrgAdminApp()" scope="col" class="table-col-9" [attr.data-identifier]="dataIdentifierPrefix + '-ssoguid'">SSO Guid
            </th>
            <th *ngIf="!isOrgAdminApp()" scope="col" class="table-col-12"
                [attr.data-identifier]="dataIdentifierPrefix + '-organization'">
                Organization
            </th>
            <th *ngIf="!eventCategory" scope="col" class="table-col-12"
                [attr.data-identifier]="dataIdentifierPrefix + '-category'">
                Category
            </th>
            <th scope="col" class="table-col-20" [attr.data-identifier]="dataIdentifierPrefix +'-eventname'">Event
                Name
            </th>
            <th scope="col" class="table-col-30" [attr.data-identifier]="dataIdentifierPrefix + '-eventDetail'">Event
                Detail
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-event>
        <tr>
            <td>{{ getEventDateTime(event) }}</td>
            <td *ngIf="isOrgAdminApp()">
                <ng-container *ngIf="!event.impersonatingUsername; else withImpersonator">
                    {{ event.username }}
                </ng-container>
                <ng-template #withImpersonator>
                    {{ event.username }} <br> (as {{ event.impersonatingUsername }})
                </ng-template>
            </td>
            <td *ngIf="!isOrgAdminApp()">{{ event.userId }}</td>
            <td *ngIf="!isOrgAdminApp()">{{ event.enterpriseName }}</td>
            <td *ngIf="!eventCategory">{{ getEventCategory(event.eventName) }}</td>
            <td>{{ getEventNameLabel(event.eventName) }}</td>
            <ng-container *ngIf="getEventDetails(event.eventDetail) as details">
                <td *ngIf="details.length > 1; else single">
                    <ul *ngFor="let detail of details">{{ detail }}</ul>
                </td>
                <ng-template #single>
                    <td>{{ details[0] }}</td>
                </ng-template>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr *ngIf="!isLoading" data-identifier="no-records">
            <td [attr.colspan]="7">
                <lib-empty-state [message]="'No audit events recorded.'"/>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer">
        <tr>
            <td [attr.colspan]="9" class="border-bottom-0 px-0 pt-3">
                <lib-pagination *ngIf="totalItems > 0"
                                [totalItems]="totalItems"
                                [currentPage]="searchRequest.pageRequest.page"
                                [itemsPerPage]="searchRequest.pageRequest.size"
                                [firstPageIdentifier]="dataIdentifierPrefix + '-pagination-first'"
                                [previousPageIdentifier]="dataIdentifierPrefix + '-pagination-previous'"
                                [currentPageIdentifier]="dataIdentifierPrefix + '-pagination-pagenumber'"
                                [nextPageIdentifier]="dataIdentifierPrefix + '-pagination-next'"
                                [lastPageIdentifier]="dataIdentifierPrefix + '-pagination-last'"
                                [viewByIdentifier]="dataIdentifierPrefix + '-pagination-viewby'"
                                (selectItemsPerPage)="onSelectItemsPerPage($event)"
                                (changeCurrentPage)="onChangeCurrentPage($event)">
                </lib-pagination>
            </td>
        </tr>
    </ng-template>
</p-table>
